import React, { useEffect, useState } from 'react';
import DocxViewerModal from './DocxViewerModal';

/** Monté une fois dans index.js. Ouvre sur l'event `pfm:open-docx`
 *  (detail : { dataUrl, filename }). */
const GlobalDocxViewer = () => {
  const [courant, setCourant] = useState(null);
  useEffect(() => {
    const onOpen = (e) => {
      const { dataUrl, filename } = e.detail || {};
      if (typeof dataUrl === 'string') setCourant({ dataUrl, filename: filename || 'document.docx' });
    };
    window.addEventListener('pfm:open-docx', onOpen);
    return () => window.removeEventListener('pfm:open-docx', onOpen);
  }, []);
  if (!courant) return null;
  return <DocxViewerModal dataUrl={courant.dataUrl} filename={courant.filename} onClose={() => setCourant(null)} />;
};

export default GlobalDocxViewer;
